var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.computedClass},[_vm._v(_vm._s(_vm.LEAVE_STATUS_TEXT[_vm.status]))])
}
var staticRenderFns = []

export { render, staticRenderFns }